import AppRoutes from "./AppRoutes";
import React from 'react';
import { Routes, Route } from 'react-router-dom';

const App = () => {

  return (
    <Routes>
      {AppRoutes.map((route, index) => {
        const { element, ...rest } = route;
        return <Route key={index} {...rest} element={element} />;
      })}
    </Routes>
  );
};

export default App;